
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftLeft0 as ObiThreewayAnalogInleftLeft0Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-left-0.js';
 
 
 

 
 export const ObiThreewayAnalogInleftLeft0 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-left-0',
   elementClass: ObiThreewayAnalogInleftLeft0Element,
   events: {
     
   }
  });
 
 